exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppointmentManager__container{padding:12% 30px 0;margin-left:auto;margin-right:auto;max-width:500px}.AppointmentManager__title{padding:0 20px 30px}.AppointmentManager__actions{margin-top:100px}.AppointmentManager__text{font-size:18px}.AppointmentManager__overflow{word-wrap:break-word;-ms-word-break:break-all;word-break:break-all;word-break:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto}.AppointmentManager__callout{white-space:pre-line;padding:24}", ""]);

// exports
exports.locals = {
	"container": "AppointmentManager__container",
	"title": "AppointmentManager__title",
	"actions": "AppointmentManager__actions",
	"text": "AppointmentManager__text",
	"overflow": "AppointmentManager__overflow",
	"callout": "AppointmentManager__callout"
};